import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddAssetModel, AddAssetResponse, BreakDownEquipmentDetails, 
    Equipment, EquipmentActualDataResult, EquipmentActualModel, 
    EquipmentActualResultModel, EquipmentDetailForKpi, 
    EquipmentMaintenanceBreakdownCountModel,
    EquipmentMake, EquipmentMakeModelModel, EquipmentSaveDetails, 
    EquipmentsResponseModel, EquipmentType, MetadataEquipmentInputModel } from './equipment';
import { FleetLevelInputModel, EquipmentLevelInputModel, ListDataInputModel, AssetTypeResponseModel, AssetResponseModel } from './equipment';
import { MetaDataRequestModel, MineDetailsResponseModel, MineAssetDetailsResponseModel } from './equipment';
import { CardMapViewDetailsRequestModel, AssetTypeDetailsRequestModel, ModelsResponseModel } from './equipment';
import { MapEquipmentsResponseModel, MapEquipmentDetailsResponseModel, EquipmentDetailsResponseModel } from './equipment';
import { MineStatusResponseModel, AssetTypeDetailsResponseModel, RefreshedTimeResponseModel } from './equipment';
import { ShiftResponseModel } from './equipment';
import { map } from 'rxjs/operators';
import { ApiResponse } from '../ApiResponse';
import { ShiftType } from '../operations-control/operations-control';
import { AppServiceService } from 'src/app/app-service.service';

@Injectable({
  providedIn: 'root'
})

export class EquipmentService {
  baseUrl?: string = '';
  //kpibaseUrl?: string = '';
  minekpibaseUrl?: string = '';
  nxtPlatformUrl?: string = '';
  token: string = '';
  private showChartType$ = new Subject<any>();
  public currentEquipmentFilter: string;
  public selectedFilterValues: any;
  public selectedPlatformId: any;
  public equipmentLocalId: string = '';
  public make: string = '';
  public model: string = '';
  public capacity: string = '';
  public equipmentStatus: string = '';
  public chartData: any;
  makeModelUrl: string;
  public equipmentClick: Boolean = false;
  public isIncludeOperators: Boolean = false;
  public currentShiftDetails: ShiftType;

  constructor(private http: HttpClient,
    private appService: AppServiceService) {
    this.baseUrl = environment.BASE_URL;
    this.minekpibaseUrl = environment.MINE_KPI_BASE_URL;
    //this.kpibaseUrl = environment.KPI_BASE_URL;
    this.nxtPlatformUrl = environment.NxtPlatform;
    this.token = environment.token;
    
  }

  public GetEquipmentDetailsByType = (type): Observable<Equipment[]> => {
    return this.http.get<Equipment[]>(this.baseUrl + "EquipmentDetails/GetEquipmentDetailsByType?type=" + type + "")
      .pipe(map((response: any[]) => {
        return response.map((equipment: any) => new Equipment(equipment));
      }));
  }

  GetAllEquipmentDetails(): Observable<Equipment[]> {
    return this.http.get<Equipment[]>(this.baseUrl + "EquipmentDetails/GetAllEquipmentDetails")
      .pipe(map((response: any[]) => {
        return response.map((equipment: any) => new Equipment(equipment));
      }));
  }

  // public GetEquipmentDetailsPagination = (page:PageModel) : Observable<Equipment[]> => {
  //   let params = new HttpParams();
  //   params = params.set('PageOffset',page.pageOffset != undefined ? page.pageOffset.toString(): "0");
  //   params = params.set('PageSize',page.pageSize != undefined ? page.pageSize.toString() : "5");
  //   params = params.set('SortCol',page.sortCol != undefined ? page.sortCol : "");
  //   params = params.set('SortOrder',page.sortOrder != undefined ? page.sortOrder.toString() : "1");
  //   return this.http.get<Equipment[]>(this.baseUrl + "EquipmentDetails/GetEquipmentDetailsPagination",{params : params});
  // }
  SaveEquipmentDetails(equipmentDetails: EquipmentSaveDetails): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl + "EquipmentDetails/SaveEquipmentDetails", equipmentDetails);
  }
  BulkEquipmentDetails(equipmentDetails: EquipmentSaveDetails[]): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl + "EquipmentDetails/BulkEquipmentDetails", equipmentDetails);
  }
  ValidateEquipmentDetails(equipmentDetails: EquipmentSaveDetails[]): Observable<Equipment[]> {
    return this.http.post<Equipment[]>(this.baseUrl + "EquipmentDetails/ValidateEquipmentDetails", equipmentDetails)
      .pipe(map((response: any[]) => {
        return response.map((equipment: any) => new Equipment(equipment));
      }));
  }
  GetEquipmentDetailById(id: number): Observable<Equipment> {
    return this.http.get<Equipment>(this.baseUrl + "EquipmentDetails/GetEquipmentDetailsById?id=" + id);
    // .pipe(map((response: any) => {
    //   return response.map((equipment: any) => new Equipment(equipment));
    // }));
  }

  UpdateEquipmentDetails(equipmentDetails: EquipmentSaveDetails): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl + "EquipmentDetails/UpdateEquipmentDetails", equipmentDetails);
  }

  DeleteEquipmentDetails(ids: string): Observable<ApiResponse> {
    const params = new HttpParams()
      .set('ids', ids);
    return this.http.delete<ApiResponse>(this.baseUrl + "EquipmentDetails/DeleteEquipmentDetails", { params });
  }
  public GetEquipmentTypes = (): Observable<EquipmentType[]> => {
    return this.http.get<EquipmentType[]>(this.baseUrl + "Common/GetEquipmentTypes");
  }
  public downloadFile(file: string): Observable<any> {
    return this.http.post(
      `${this.baseUrl}EquipmentDetails/download?file=${file}`,
      { path: file },
      {
        observe: 'response',
        responseType: 'blob'
      });
  }

  setChartType(chartType: string) {
    this.showChartType$.next(chartType);
  }

  getChartSubject() {
    return this.showChartType$.asObservable();
  }

  // Realtime API calls 
  GetFleetLevelChartDetails(fleetDetails: any): Observable<any> {
    //'Authorization', `Bearer ${this.token}`
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.appService.getUserToken()}`
          // 'skip': 'true',
          // 'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<any>(this.minekpibaseUrl + "preview", fleetDetails, {...httpOptions, observe: 'response',});
  }

  GetFleetLevelDataResult(fleetLevelInput: any): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }

      )
    };

    return this.http.post<any>(this.minekpibaseUrl + "preview", fleetLevelInput, httpOptions);
  }

  GetEquipmentLevelChartDetails(equipmentDetails: EquipmentLevelInputModel): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };

    return this.http.post<any>(this.minekpibaseUrl + "preview", equipmentDetails, httpOptions);
  }

  GetEquipmentLevelDataResult(equipmentLevelInput: EquipmentLevelInputModel): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          // 'skip': 'true',
         'Authorization': `Bearer ${this.appService.getUserToken()}`//`Bearer ${this.token}`
         
        }
      )
    };

    return this.http.post<any>(this.minekpibaseUrl + "preview", equipmentLevelInput, {...httpOptions, observe: 'response',});
  }

  GetEquipmentDumperActualDataResult(equipmentInput: EquipmentActualModel): Observable<EquipmentActualResultModel> {

    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<EquipmentActualResultModel>(this.minekpibaseUrl + "dumper_actual", equipmentInput, httpOptions);
  }

  GetEquipmentExcavatorActualDataResult(equipmentInput: EquipmentActualModel): Observable<EquipmentActualResultModel> {

    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<EquipmentActualResultModel>(this.minekpibaseUrl + "excavator_actual", equipmentInput, httpOptions);
  }

  GetEquipmentDrillerActualDataResult(equipmentInput: EquipmentActualModel): Observable<EquipmentActualResultModel> {

    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<EquipmentActualResultModel>(this.minekpibaseUrl + "driller_actual", equipmentInput, httpOptions);
  }

  GetEquipmentLoaderActualDataResult(equipmentInput: EquipmentActualModel): Observable<EquipmentActualResultModel> {

    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<EquipmentActualResultModel>(this.minekpibaseUrl + "loader_actual", equipmentInput, httpOptions);
  }


  GetMinMaxResult(equipmentLevelInput: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<any>(this.minekpibaseUrl + "current_lsf", equipmentLevelInput, httpOptions);
  }
  GetAssetDataResult(dataInputModel: ListDataInputModel): Observable<AssetTypeResponseModel> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<AssetTypeResponseModel>(this.minekpibaseUrl + "generic/list", dataInputModel, httpOptions);
  }

  GetAssetTypeDataResult(dataInputModel: ListDataInputModel): Observable<AssetTypeResponseModel> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<AssetTypeResponseModel>(this.minekpibaseUrl + "generic/list", dataInputModel, httpOptions);
  }

  GetModelsDataResult(dataInputModel: ListDataInputModel): Observable<ModelsResponseModel> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<ModelsResponseModel>(this.minekpibaseUrl + "generic/list", dataInputModel, httpOptions);
  }



  GetEquipmentDataResult(dataInputModel: ListDataInputModel): Observable<AssetResponseModel> {

    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<AssetResponseModel>(this.minekpibaseUrl + "generic/list", dataInputModel, httpOptions);
  }

  GetShiftsDataResult(dataInputModel: ListDataInputModel): Observable<ShiftResponseModel> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<ShiftResponseModel>(this.minekpibaseUrl + "generic/list", dataInputModel, httpOptions);
  }

  GetMetadataResult(dataInputModel: MetaDataRequestModel): Observable<MineDetailsResponseModel> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<MineDetailsResponseModel>(this.minekpibaseUrl + "mines", dataInputModel, httpOptions);
  }

  GetMineAssetDetailsMetadataResult(dataInputModel: MetaDataRequestModel): Observable<MineAssetDetailsResponseModel> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<MineAssetDetailsResponseModel>(this.minekpibaseUrl + "mines", dataInputModel, httpOptions);
  }

  // Dashboard API calls

  GetMapEquipmentsResult(dataInputModel: CardMapViewDetailsRequestModel): Observable<MapEquipmentsResponseModel> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<MapEquipmentsResponseModel>(this.minekpibaseUrl + "GetMapEquipments", dataInputModel, httpOptions);
  }

  GetMapEquipmentDetailsResult(dataInputModel: CardMapViewDetailsRequestModel): Observable<MapEquipmentDetailsResponseModel> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };

    return this.http.post<MapEquipmentDetailsResponseModel>(this.minekpibaseUrl + "GetMapEquipmentDetails", dataInputModel, httpOptions);
  }

  GetEquipmentDetailsResult(dataInputModel: CardMapViewDetailsRequestModel): Observable<EquipmentDetailsResponseModel> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<EquipmentDetailsResponseModel>(this.minekpibaseUrl + "GetEquipmentDetails", dataInputModel, httpOptions);
  }

  GetMineStatusResult(dataInputModel: CardMapViewDetailsRequestModel): Observable<MineStatusResponseModel> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };

    return this.http.post<MineStatusResponseModel>(this.minekpibaseUrl + "GetMinesStatus", dataInputModel, httpOptions);
  }


  GetAssetTypeDetailsResult(dataInputModel: AssetTypeDetailsRequestModel): Observable<AssetTypeDetailsResponseModel> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<AssetTypeDetailsResponseModel>(this.minekpibaseUrl + "GetAssetTypeDetails", dataInputModel, httpOptions);
  }

  GetEquipmentMetadataDetails(requestInput: MetadataEquipmentInputModel): Observable<EquipmentsResponseModel> {

    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<EquipmentsResponseModel>(this.minekpibaseUrl + "device_list", requestInput, httpOptions);
  }

  GetBreakdownEquipmentDetails(assetType: string): Observable<BreakDownEquipmentDetails[]> {
    return this.http.get<BreakDownEquipmentDetails[]>(this.baseUrl + "EquipmentDetails/GetEquipmentBreakdownMaintenance?equipmentType=" + assetType);
  }

  GetARefreshedTimeResult(dataInputModel: CardMapViewDetailsRequestModel): Observable<RefreshedTimeResponseModel> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<RefreshedTimeResponseModel>(this.minekpibaseUrl + "GetRefreshedTime", dataInputModel, httpOptions);
  }

  GetTripWiseData() {
    return this.http.get("assets/TripwiseChartResponse.json");
  }

  GetEquipmentDetail(equipmentName: string): Observable<EquipmentDetailForKpi> {
    return this.http.get<EquipmentDetailForKpi>(this.baseUrl + "EquipmentDetails/GetEquipmentDetail?equipmentName=" + equipmentName);
  }

  GetEquipmentMakeModel(equipmentName: string): Observable<EquipmentMakeModelModel> {
    return this.http.get<EquipmentMakeModelModel>(this.baseUrl + "EquipmentDetails/GetEquipmentMakeModel?equipmentName=" + equipmentName);
  }

  GetEquipmentMakeModelDetails(equipmentType: string, unitId:number, customerId:number): Observable<EquipmentMakeModelModel[]> {
    return this.http.get<EquipmentMakeModelModel[]>(this.baseUrl + "EquipmentDetails/GetEquipmentMakeModel?equipmentName=" + equipmentType + "&unitId=" + unitId + "&customerId=" + customerId);
  }

  public GetEquipmentMovementType = (): Observable<any[]> => {
    return this.http.get<[]>(this.baseUrl + "Common/GetEquipmentMovementType");
  }
  
  GetEquipmentMaintenanceBreakdownCount(mineid: number, assettypeid: number): Observable<EquipmentMaintenanceBreakdownCountModel> {
    return this.http.get<EquipmentMaintenanceBreakdownCountModel>(this.baseUrl + "EquipmentMaintenancePlan/GetEquipmentMaintenanceBreakdownCount?mineid=" + mineid + "&assetTypeId=" + assettypeid);
  }


  AddAsset(addAssetModel: AddAssetModel): Observable<AddAssetResponse> {
    return this.http.post<AddAssetResponse>(this.nxtPlatformUrl + "PlatformAssetManagement/AddAsset", addAssetModel);
  }

  GetEquipmentMake(equipmentName: string): Observable<EquipmentMake[]> {
    return this.http.get<EquipmentMake[]>(this.baseUrl + "EquipmentDetails/GetEquipmentMake?equipmentName=" + equipmentName);
  }

  GetAssetIdByName(equipmentName: string): Observable<any> {
    return this.http.get<any>(this.baseUrl + "EquipmentDetails/GetAssetIdByName?equipmentName=" + equipmentName);
  }
  GetEquipmentMasterData(): Observable<any> {
    return this.http.get<any>(this.baseUrl + "Common/GetEquipmentMasterData");
  }
  private _listners = new Subject<any>();
  listen(): Observable<any> {
    return this._listners.asObservable();
  }
  filter(event) {
    this._listners.next(event);
  }


  GetEquipmentTripDetails(data: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };
    return this.http.post<any>(this.minekpibaseUrl + "trip_details", data, httpOptions);
  }


  GetEquipmentGanttChartDetails(data: any): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'skip': 'true',
          'Authorization': `Bearer ${this.token}`
        }
      )
    };

    return this.http.post<any>(this.minekpibaseUrl + "summary/preview", data, httpOptions);
  }

  GetEquipmentCanOrFuel(equipmentName: string): Observable<any> {
    return this.http.get<any>(this.baseUrl + "EquipmentDetails/GetEquipmentCanOrFuel?equipmentName=" + equipmentName);
  }
  
}
